module.exports = __webpack_public_path__ + "img/info.ac908678.svg";